import { Component } from '@angular/core';
import { LeftSplitviewComponent } from '../../components/left-splitview/left-splitview.component';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-email-got-verified',
    templateUrl: './email-got-verified.component.html',
    styleUrls: ['./email-got-verified.component.scss'],
    imports: [
        LeftSplitviewComponent,
        MatButton,
        RouterLink,
        TranslateModule,
    ],
})
export class EmailGotVerifiedComponent {
    constructor() {}
}
